import React, { ReactNode, useState } from "react";
import './ExcelExportButton.scss';
import { useTranslation } from "react-i18next";
import { logUiEvent } from "../../../adapters/FrontEndUiEventAdapter";
import { Icons } from "@cd/sdds-common-components-react";
import { CustomModal } from "@cd/sdds-common-components-react";
import { RBACWrapper } from "react-simple-rbac-reactjs-18";


type ExcelExportProps = {
  fromDate?: string
  toDate?: string
  externalEquipmentReference: string
  children?: ReactNode
  disabled: boolean
  onExportViaBackend: () => void
  onExportViaFrontEnd: () => void
}

const CommHistoryExcelExportButton = ({ children, disabled, fromDate, toDate, externalEquipmentReference, onExportViaBackend, onExportViaFrontEnd }: ExcelExportProps) => {

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { t } = useTranslation();
  const formatDateTime = (date?: Date | string) =>
    date ? new Date(date).toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short', hourCycle: 'h23', timeZone: 'UTC' }) : '';

  const handleFullRangeClick = () => setShowConfirmModal(true);

  const handleExportFullRangeConfirm = () => {
    logUiEvent(`All messages : ExcelExport CommunicationHistory ${externalEquipmentReference}`);
    onExportViaBackend();
    setShowConfirmModal(false);
  }
  const handleExportCurrentRangeClick = () => {
    logUiEvent(`Loaded messages : ExcelExport CommunicationHistory ${externalEquipmentReference}`);
    onExportViaFrontEnd()
  }

  const handleCancelButton = () => {
    setShowConfirmModal(false);
  }

  return (
    <div className={`excel-export ${disabled ? "is-disabled" : ""}`}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
    >
      <div className='qs-btn' id="excel-export">{t("TS_core:Export")}<Icons.ArrowDown show={true} color={disabled ? "#0D0F13" : "#ffffff"} /></div>
      <div className="qs-options-container">
        <button
          type="button"
          id="excel-export-loadedMessages-btn"
          className="sdds-btn-fullbleed sdds-btn sdds-btn-sm sdds-btn-ghost qs-options"
          onClick={handleExportCurrentRangeClick}>
          {t("TS_core:Loaded_messages")}
        </button>
        <RBACWrapper oneOf requiredRoles={["Admin", "GTS", "LoTH", "FQ"]}>
          <button
            type="button"
            id="excel-export-AllMessages-btn"
            className="sdds-btn-fullbleed sdds-btn sdds-btn-sm sdds-btn-ghost qs-options"
            onClick={handleFullRangeClick}>
            {t("TS_core:All_messages")}
          </button>
        </RBACWrapper>
      </div>
      <CustomModal
        id="Export-data-modal"
        title={t("TS_core:ExportAllMessagesInFullRangeTitle")}
        size="sm"
        handleClose={() => setShowConfirmModal(false)}
        show={showConfirmModal}
        actions={
          <>
            <button
              type="button"
              className="sdds-btn sdds-btn-sm sdds-btn-primary bttn"
              onClick={handleExportFullRangeConfirm}
            >
              {t("TS_core:Proceed")}
            </button><button
              type="button"
              className="sdds-btn sdds-btn-sm sdds-btn-secondary bttn"
              onClick={handleCancelButton}
            >
              {t("TS_core:Cancel")}
            </button>
          </>
        }
      >
        <div>
          <p>
            {t("TS_core:ExportAllMessagesInFullRangeLineOne")}
          </p>
          <strong>
            {t("TS_core:From")}{` ${formatDateTime(fromDate)}`} - {t("TS_core:To")} {` ${formatDateTime(toDate)}`}
          </strong>
          <p>
            {t("TS_core:ExportAllMessagesInFullRangeLineThree")}
          </p>
        </div>
      </CustomModal>
    </div>
  );
}

export default CommHistoryExcelExportButton;
